import { createSelector } from 'reselect';

const getInsurance = state => state.insurance;

export const isInsuranceComplete = createSelector([getInsurance], (state) => {
    return state.provider === "" || state.selected !== "" || state.declined === true;
});
